import styled from 'styled-components'

export const Wrapper = styled.div``

export const Link = styled.a`
  width: 100%;
`
